import { CountResponse } from '@interfaces/common.interface';
import {
  ActivateUserRequest,
  ApproveCustomerRequest,
  CountUsersRequestParams,
  CreatePasswordlessUserRequestBody,
  GetUsersRequestParams,
  RequestUserActivationRequest,
  User,
  UserPatchRequest,
} from '@interfaces/users.interface';

import api from './';

export const {
  usePatchCurrentUserMutation,
  useRequestActivationMutation,
  useVerifyActivationTokenQuery,
  useActivateMutation,
  useCountUsersQuery,
  useGetUsersQuery,
  useGetUserByIdQuery,
  useDeleteUserMutation,
  useCreatePasswordlessAdminMutation,
  useActivateUserMutation,
  useDeactivateUserMutation,
  useApproveCustomerMutation,
} = api.injectEndpoints({
  endpoints: (build) => ({
    patchCurrentUser: build.mutation<User, UserPatchRequest>({
      query: (body) => ({
        url: 'users/me',
        method: 'PATCH',
        body,
      }),
    }),
    requestActivation: build.mutation<void, RequestUserActivationRequest>({
      query: (body) => ({
        url: `users/activate/request`,
        method: 'POST',
        body,
      }),
    }),
    verifyActivationToken: build.query<void, string>({
      query: (token) => ({
        url: `users/activate/${token}`,
        method: 'GET',
      }),
    }),
    activate: build.mutation<void, ActivateUserRequest>({
      query: ({ token, body }) => ({
        url: `users/activate/${token}`,
        method: 'POST',
        body,
      }),
    }),
    countUsers: build.query<CountResponse, CountUsersRequestParams>({
      query: (params) => ({
        url: 'users/count',
        params,
      }),
      providesTags: ['users'],
    }),
    getUserById: build.query<User, number>({
      query: (id) => ({
        url: `users/${id}`,
      }),
      providesTags: ['users'],
    }),
    getUsers: build.query<User[], GetUsersRequestParams>({
      query: (params) => ({
        url: 'users',
        params,
      }),
      providesTags: ['users'],
    }),
    deleteUser: build.mutation<void, number>({
      query: (id) => ({
        url: `users/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['users'],
    }),
    activateUser: build.mutation<User, number>({
      query: (id) => ({
        url: `users/${id}/activate`,
        method: 'POST',
      }),
      invalidatesTags: ['users', 'customers'],
    }),
    deactivateUser: build.mutation<User, number>({
      query: (id) => ({
        url: `users/${id}/deactivate`,
        method: 'POST',
      }),
      invalidatesTags: ['users', 'customers'],
    }),
    createPasswordlessAdmin: build.mutation<
      User,
      CreatePasswordlessUserRequestBody
    >({
      query: (body) => ({
        url: 'users/admin',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['users'],
    }),
    approveCustomer: build.mutation<User, ApproveCustomerRequest>({
      query: ({ id, body }) => ({
        url: `users/${id}/approve`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['users', 'customers'],
    }),
  }),
});
